/**
 * A list in words (TMMPDM-0113): "A, B and C" as the locale joins it (Intl `ListFormat`, a conjunction).
 * Used for a refusal that names several things, such as the gates an approval failed.
 */
export function formatList(items: readonly string[], locale: string): string {
  try {
    return new Intl.ListFormat([locale], { style: 'long', type: 'conjunction' }).format(items);
  } catch {
    return items.join(', ');
  }
}
